<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.products.banners')">Product Banners</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Update
    </h1>
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <Form @submit="handleForm" :deleteAction="handleDelete" :form-data="form" :processing="processing"></Form>
      </div>

    </div>
  </div>

</template>

<script>
import Form from './Form'
import Layout from '@/Shared/Admin/Layout'
import {Inertia} from '@inertiajs/inertia'

export default {
  name: 'Edit',
  components: { Form },
  layout: Layout,

  props: {
    banner: Object,
  },

  data() {
    return {
      processing: false,
      form: this.$inertia.form(this.banner)
    }
  },

  methods: {
    handleForm(formData) {

      this.processing = true
      Inertia.post(this.route('manage.products.banners.update', this.banner.id),{_method: 'put', ...formData}, {
        onFinish : () => {
          this.processing = false
        }
      })
    },

    handleDelete() {
      if(confirm('Are you sure you want to delete this?')) {
        Inertia.delete(this.route('manage.products.banners.destroy', this.banner.id))
      }
    }
  }

}
</script>
